export default __webpack_public_path__ + "0c2bb6014f94a3781a0cb2ff7ab28913.svg";